import {formatDateSpelled} from "../../../utils/appLocale";

export const ITEM_TYPE_LABEL: Record<string, string> = {
  appointment: "Appointment",
  membership: "Membership",
  package: "Package",
  fee: "Fee",
};

/**
 * A date on the money screens, in the app's language.
 *
 * This used to pass `undefined` as the locale, which follows the READER's
 * machine rather than the application's: on a Spanish-configured browser the
 * billing list read "29 ago 2026" and "14 sept 2026" — Spanish months inside
 * English copy, on the screen where a patient reads what they owe.
 *
 * `utils/appLocale` was written for exactly this and these two call sites were
 * never moved onto it. One helper, so a guardian and a patient reading the same
 * balance can never see the same date written two ways.
 */
export function formatDate(epochMs: number | null | undefined) {
  return formatDateSpelled(epochMs);
}
